import { Divider, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { ChevronRight as ChevronRightIcon } from "@mui/icons-material";
import { NavLink } from "react-router-dom";

export default function SectionItem(props) {
  const { to, primary, secondary, disabled, disableGutters, onClick, icon, disableIcon, disableDivider } = props;

  return (
    <NavLink to={disabled ? undefined : to}>
      <ListItemButton disabled={disabled} disableGutters={disableGutters} onClick={onClick}>
        <ListItemText
          primary={primary}
          secondary={secondary}
        />
        {
          !disableIcon ? (
            <ListItemIcon>
              {
                !!icon ? icon : <ChevronRightIcon />
              }
            </ListItemIcon>
          ) : null
        }
      </ListItemButton>
      {
        !disableDivider ? (
          <Divider />
        ) : null
      }
    </NavLink>
  );
}
